import React,{ useState, useEffect, useContext } from 'react';
import { Outlet, NavLink } from "react-router-dom";
import { useMediaQuery } from 'react-responsive';
import useWindowSize from './hooks/useGatsbyWindowSize';
import useBodyPathClasses from './hooks/useBodyPathClasses';
/* import AnimatedCursor from "react-animated-cursor"; */

import {
  CookieConsentProvider,
  CookieBanner,
  FloatingConsentInfo,
  CookieService
} from "@vantezzen/react-cookie-banner";


import Navbar from "./component/Navbar";
import Footer from "./component/Footer";


import { ThemeContext } from './context/ThemeContext';
import './index.css';

function App() {

 useBodyPathClasses();


const {width,height} = useWindowSize();
const vertical = useMediaQuery({ query: `(orientation: portrait)` }); //detecting orientation vs max-width: 821px;

const theme = useContext(ThemeContext);



  useEffect(()=> {
    //console.log(width,height);
    theme.dispatch({pushOut:false, width:width, height:height, vertical:vertical,type: 'viewport' });

  },[width,height,vertical])

  useEffect(()=> {
  var touchRegionElement = document.getElementById('app');
  /*  var _cursor_ = touchRegionElement.getElementsByTagName('div')[0]; */

/*  function showCoordinates(e) {
     _cursor_.style.left = `${e.touches[0].clientX}`;
     _cursor_.style.top = `${e.touches[0].clientY}`;
  }*/

/*
  touchRegionElement.addEventListener('touchstart', showCoordinates);
  touchRegionElement.addEventListener('touchend', showCoordinates);
  touchRegionElement.addEventListener('touchmove', showCoordinates);
  */

  },[width])

  return (

    <div id="app">
  {/*  <AnimatedCursor
    className="cs"
    data-cursor="1"
    showSystemCursor={true}
    trailingSpeed={12}
    innerSize={18}
      outerSize={8}
      color='255, 255, 255'
      outerAlpha={0.1}
      innerScale={0.7}
      outerScale={2}
      outerSize={25}
      outerStyle={{
        boxShadow:'0 0 3px #fff, -3px 0 8px #f0f, 3px 0 8px #0ff'
  }}
  innerStyle={{
    backgroundColor: 'transparent'
  }}
      hasBlendMode={true}
      clickables={[
        'a',
        'input[type="text"]',
        'input[type="email"]',
        'input[type="number"]',
        'input[type="submit"]',
        'input[type="image"]',
        'label[for]',
        'select',
        'textarea',
        'button',
        '.link'
      ]}
  />*/}
   <Navbar />
{/* #c5d24c */}
   <div id="main" style={{minHeight:100+'vh',width:'100%'}} className="bg-zinc-900 relative">
     <div style={{zIndex:99999}} className=" absolute left-3 md:left-1 lg:left-2 top-1 md:top-2">
       <a href="/" aria-label="home" className="">
         <svg className="brandLogo" width="240" height="180"
         xmlns="http://www.w3.org/2000/svg"
         viewBox="0 0 300 200"
         fill="currentColor">
         <path className="st0" d="M46.75,39.15c.34-.16.63-.51.87-.8,3.57-4.37,6.79-9.93,10.17-14.59,1.64-2.26,6.11-8.9,8.03-10.24,1.66-1.16,4.97-.67,6.77.08,2.36.98.87,2.56.25,4-3.34,7.78-8.52,18-10.56,25.99-.31,1.23-1.64,6.49,1.07,4.4.74-.57,3.83-4.33,4.26-5.17,3.42-6.69,9.2-17.84,18.15-17.24,2.66.18,5.71,1.6,5.2,4.72,1.82-2.34,2.49-4.44,5.99-4.12,1.29.12,3.82,1.04,3.09,2.7-2.89,5.38-7.3,11.65-9.03,17.5-1.16,3.93,1.4,3.62,3.78,1.62,5.81-4.88,8.82-11.43,12.27-17.99-1.88-.34-4.24-2.15-2.55-4.13,1.3-1.52,3.29-.07,4.91-.18l3.42-7.01c.91-1,5.71-.69,6.42.49.98,1.66-1.61,4.51-1.98,6.2,1,.06,2.04-.08,3.04,0,1.66.13,3.78.09,3.36,2.36-.61,3.31-6.84,1.24-8.97,2.24-2.05,4.18-4.62,8.31-6.51,12.55-.89,2-3.9,8.17,1.01,6.51,2.09-.7,6.86-4.77,8.15-6.59.91-1.27,1.63-3.39,2.43-4.84,2.63-4.71,6.38-9.44,11.63-11.36,4.3-1.57,10.04-.62,9.41,5.08-.35,3.18-4.19,7.65-7.03,3.99.47-.88,3.58-5.41,2.54-6.14-1.28-.47-2.78.83-3.66,1.67-2.95,2.84-6.57,9.21-7.43,13.21-1.59,7.42,4.08,6.09,8.38,3.27,3.14-2.05,6.17-4.82,8.03-8.09,4.58-8.06,8.12-17,12.58-25.15.65-1.05,2.45-1.14,3.61-1.12.62.01,2.8.24,3.22.51.48.31.71.96.56,1.51-2.91,6.29-6.21,12.39-9.59,18.42.37.09.47-.21.69-.39,2.76-2.32,4.77-4.91,8.28-6.46,3.94-1.74,8.71-.92,7.88,4.35-.57,3.61-5.28,10.67-6.87,14.55-.44,1.09-1.75,4.5.67,4.03,1.45-.29,4.26-3.41,5.25-4.59.45-.54,2.66-3.74,2.89-3.81.89-.26,1.87,1.42,1.85,2.23-.03,1.13-1.52,2.98-2.27,3.84-2.84,3.3-9.51,9.76-14.24,8.15-8.21-2.79,2.3-17.2,4.02-21.71.28-.73.93-1.9-.16-2.13-.78.07-4.92,3.86-5.74,4.67-1.46,1.44-3.34,3.44-4.61,5.02-2.97,3.72-4.43,8.79-7.03,12.82-1.35,2.24-7.72,1.26-7.51-1.4.04-.52,1.09-2.54.97-2.68-4.17,3.44-8.72,7.01-14.49,5.36-3.56-1.02-4.92-4.01-4.86-7.52-2.93,2.63-5.68,5.44-9.48,6.83-5.2,1.9-10.27.63-8.7-5.84-2.9,2.8-6.24,6.3-10.53,6.66-3.92.32-6.49-2.69-5.28-6.46-2.02,1.8-3.58,4.01-6.06,5.34-4.88,2.62-9.92.56-10.45-5.14-2.69,3.29-6.02,7.94-10.91,5.8-4.4-1.93-1.74-8.09-.59-11.4,1.59-4.59,4.66-10.21,5.8-14.63.09-.33.14-.64.09-.98l-.75.52c-5.24,7.27-9.71,15.15-14.89,22.45-1.31,1.85-1.83,2.14-4.06,1.35-1.34-.47-3.24-1.6-3.29-3.2,1.32-6.66,3.48-13.3,4.83-19.93.04-.21.23-.66,0-.79-.59.5-.93,1.19-1.31,1.83-5.12,8.5-9.28,17.59-13.95,26.33-1.67,2.09-6.71-.68-6.21-3.65.23-1.4,4.46-7.46,5.49-9.25,2.4-4.17,4.6-8.47,7.01-12.64,2.96-5.15,6.22-11.62,9.58-16.36,1.45-2.04,2.21-1.95,4.71-1.79,1.77.11,4.57.33,4.42,2.65-1.21,5.72-2.92,11.31-4.23,17.01-.5,2.18-1.1,4.47-1.27,6.68ZM86,29.95c-3.57.71-8.65,8.79-10,12.01-.72,1.71-3.12,8.97,1.1,7.38,3.02-1.13,9.33-11.05,10.34-14.22.47-1.46,1.29-5.72-1.43-5.17Z"/>
  <path className="st0" d="M189.21,53.89c2.36-.07,4.3,1.26,3.94,3.84-.18,1.3-.86.68-1.67.67-1.52-.02-4.35.26-5.67-.03-1.41-.32-2.37-4.22-3.67-5.37-.81-.72-2.4-.92-3.36-1.39,0-6.16-3.33-11.77-3.72-17.86-.21-3.21-.25-8.43.49-11.49.35-1.44,1.66-3.83,1.69-5.01.03-1.09-.83-2.63-1.1-3.83-.4-1.71-1.23-7.44-.27-8.73.75-1.02,2.33.3,3.02.87,1.6,1.32,2.84,3.4,4.43,4.61.2.15.25.38.59.29-.02-1.24.94-6.13,1.86-6.69,1.1-.68,1.8,1.04,2.09,1.87.35,1.04.83,4.83,1.37,5.31.61.55,2.56.68,3.33,1.39.46.43.41,1.15.71,1.65.82,1.37,5.64,1.63,7.22,1.82,1.13.65.29,2.22-.15,3.11-.69,1.37-2.16,3.06-3.58,3.69-.88.38-3.96.74-4.15,1.55-.17.71,1.32,5.35,1.51,6.68.64,4.57.04,9-2.64,12.82-.76,1.08-1.78,1.81-2.4,2.91l.15,7.33ZM189.94,14.22c-.66.19-1.04,1.27-.45,1.75,1,.81,1.69-.94,1.11-1.7-.19-.14-.44-.11-.66-.05Z"/>
  <path className="st0" d="M162.88,61.35l-8.68,36.32-8.32-.16-9.04-23.59-5.62,23.47c-.07.14-.19.2-.32.27-.65.38-6.79.39-7.33-.06-.2-.16-.23-.32-.19-.56l8.54-35.5,8.32-.16,9.46,24.33,5.8-24.37h7.37Z"/>
  <path className="st0" d="M91.31,60.43c25.31-2.19,18.38,35.15-3.23,37.84-27.26,3.39-19.07-35.92,3.23-37.84ZM90.52,67.1c-11.95,1.62-17.24,29.07-1.02,24.33,5.71-1.67,9.17-9.12,9.53-14.64.41-6.31-1.27-10.66-8.51-9.69Z"/>
  <path className="st0" d="M230.64,42.17c0,9.27-7.52,16.79-16.79,16.79s-16.79-7.52-16.79-16.79,7.52-16.79,16.79-16.79,16.79,7.52,16.79,16.79ZM212.74,28.97c-1.28.23-2.44,1.6-2.65,2.85-.46,2.7,2.15,5.09,4.75,3.96,3.81-1.66,2.11-7.58-2.1-6.81ZM204.1,36.05c-1.35.28-2.48,1.71-2.65,3.05-.44,3.52,4.03,5.68,6.24,2.7,1.99-2.68-.3-6.43-3.59-5.75ZM222.17,36.05c-4.11.86-2.93,7.94,1.68,6.98s3.14-7.99-1.68-6.98ZM215.59,42.07c0-1.05-.85-1.9-1.9-1.9s-1.9.85-1.9,1.9.85,1.9,1.9,1.9,1.9-.85,1.9-1.9ZM205.59,47.27c-2.97,2.78.59,8.13,4.35,5.43,4.01-2.87-.86-8.7-4.35-5.43ZM218.65,46.66c-1.26.16-2.63,1.39-2.86,2.65-.7,3.83,4.4,5.79,6.52,2.59,1.67-2.52-.84-5.61-3.67-5.24Z"/>
  <path className="st0" d="M59.08,61.21c16.3-.65,13.36,19.43.93,23.14-4.57,1.37-9.37.49-14.06.87l-3.12,12.21c-.8.65-1.84.31-2.64.35-.93.04-5.11.53-5.41-.4l8.32-35.83c.14-.22.37-.19.58-.2,4.04-.3,10.33.15,15.39-.13ZM47.53,78.45h7.57c3.86,0,7.02-3.28,6.77-7.14-.33-5.09-8.67-3.06-11.97-3.47l-2.36,10.61Z"/>
  <path className="st0" d="M196.78,61.16l.27.33-1.37,6.33-11,.14-7.54,29.76h-7.47c-.07,0-.31-.21-.47-.22l7.06-29.45h-10.51c-.47-.32-.1-1.05,0-1.57.24-1.25.66-3.5,1.09-4.61.11-.3.21-.51.49-.69h29.48Z"/>
  <path className="st0" d="M116.11,61.35h7.76c.58,0,.08,1.78,0,2.16-2.24,11.25-5.66,22.52-8.11,33.75-.07.2-.2.3-.38.41-.6.35-5.66.33-6.65.24-.41-.04-1.23-.08-1.23-.65l8.61-35.91Z"/>
  <path className="st0" d="M239.52,58.01c-4.9.94-10.22.78-14.94-.88,1.76-1.02,3.18-2.43,4.31-4.12,3.5.53,7.19.75,10.62-.3v5.31Z"/>


         </svg>
       </a>
     </div>
     <Outlet/>
</div>


<Footer/>

<CookieConsentProvider>
      <CookieBanner
        id="ckb"
        lang={{
    title: "Cookie consent",
    description:
      'We use cookies to enhance your browsing experience. By clicking "Accept All", you consent to our use of cookies.',
    required: "Required",

    privacyPolicyInfo: "For more information, please visit our",
    privacyPolicy: "Privacy Policy",

    acceptAll: "Accept all",
    saveSelection: "Save selection",
    disableAll: "Disable all",

    essential: "Essential",
    marketing: "Marketing",
    analytics: "Analytics",
    other: "Other",
  }}
    />
      <FloatingConsentInfo />
      <CookieService>
        {/* External scripts/components go here */}

      </CookieService>
    </CookieConsentProvider>

</div>


  );
}

export default App;
